export const InplaceDT = {
	inplace: {
		css: ({ dt }) => `
              .p-inplace-no-padding {
                .p-inplace-display {
                    padding: 0;
                 }
              }
              .p-inplace-center-view-text {
                .p-inplace-display {
                    width: 100%;
                    text-align: center;
                }
              }
        `,
	},
};
